import React from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox, Form } from 'antd';

const RegisterCondition = () => {
  const { t } = useTranslation();

  return (
    <div>
      <Form.Item
        style={{ textAlign: 'left' }}
        name="information-is-valid"
        valuePropName="checked"
        rules={[
          {
            validator: (_, value) =>
              value
                ? Promise.resolve()
                : Promise.reject(t('login.information-is-valid-missing'))
          }
        ]}
      >
        <Checkbox>{`${t('login.information-is-valid')} `}</Checkbox>
      </Form.Item>
    </div>
  );
};

export default RegisterCondition;
